/** @jsxImportSource ../../i18n */
import React from 'react';
import { createPortal } from 'react-dom';
import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';
import { cx } from '../../theme/cx';
import { useToastState } from '../../contexts/ToastContext';

const TONES = {
  success: [CheckCircle2, 'text-gain-400'],
  error: [AlertCircle, 'text-loss-400'],
  info: [Info, 'text-gold-400'],
};

export const Toaster = () => {
  const { toasts, toast, pause, resume } = useToastState();
  if (typeof document === 'undefined') return null;
  return createPortal(
    <section
      aria-label="Notifications"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-4 top-[calc(var(--topbar-h)+0.75rem)] z-toast flex flex-col items-center gap-2 sm:inset-x-auto sm:right-6 sm:items-end"
    >
      {toasts.map((t) => {
        const [Icon, iconClass] = TONES[t.tone] || TONES.info;
        return (
          <div
            key={t.id}
            role={t.tone === 'error' ? 'alert' : 'status'}
            onMouseEnter={() => pause(t.id)}
            onMouseLeave={() => resume(t.id)}
            onFocus={() => pause(t.id)}
            onBlur={() => resume(t.id)}
            className="pointer-events-auto flex w-full max-w-sm animate-toast-in items-start gap-3 rounded-control border border-line-strong bg-surface-3/95 px-4 py-3 shadow-pop backdrop-blur-md"
          >
            <Icon size={18} className={cx('mt-0.5 flex-shrink-0', iconClass)} aria-hidden="true" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-fg">{t.title}</p>
              {t.description && <p className="mt-0.5 text-[13px] leading-relaxed text-fg-muted">{t.description}</p>}
            </div>
            <button type="button" onClick={() => toast.dismiss(t.id)} aria-label="Fermer la notification" className="-mr-1 inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md text-fg-subtle transition-colors hover:bg-surface-2 hover:text-fg">
              <X size={14} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </section>,
    document.body,
  );
};
